'use client';

/**
 * Jedyny interaktywny fragment strony RODO — wydzielony do własnej wyspy klienckiej,
 * żeby cała treść klauzuli mogła renderować się serwerowo (widoczna dla Google i botów AI).
 */
export default function BackButton() {
  return (
    <button
      type="button"
      onClick={() => window.history.back()}
      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
    >
      Powrót
    </button>
  );
}
